export default class ResponsibleAttendantModel {
  id?: number | null;

  usuario!: string;
}
